import { ProprietaMisurataDto } from "@/api";
import typography from "@/theme/base/typography";
import { proprietaMisurataFormat } from "@/utils/proprietaMisurataUtils";
import { ChartData, ChartDataset, ChartOptions } from "chart.js";

function configs(
  datasets: ChartDataset<"line", { x: number; y: number | null }[]>[],
  proprietaMisurate: ProprietaMisurataDto[],
  rpmAxisMax?: number | null
): {
  data: ChartData<"line">;
  options: ChartOptions<"line">;
} {
  const yAxes: ChartOptions<"line">["scales"] = {};

  for (const p of proprietaMisurate) {
    const type = p.type;
    if (type) {
      const unit = type.unit ?? "scalar";
      const axis = yAxes[unit];
      const asseYAuto = type.graficoAsseYAutomatico === true;
      if (axis) {
        if (asseYAuto) {
          if ("suggestedMin" in axis && typeof axis.suggestedMin === "number") {
            if (typeof type.percentMin === "number") {
              axis.suggestedMin = undefined;
            }
          }
          if ("suggestedMax" in axis && typeof axis.suggestedMax === "number") {
            if (typeof type.percentMax === "number") {
              axis.suggestedMax = undefined;
            }
          }
        } else {
          if ("suggestedMin" in axis && typeof axis.suggestedMin === "number") {
            if (typeof type.percentMin === "number") {
              axis.suggestedMin = Math.min(axis.suggestedMin, type.percentMin);
            }
          }
          if ("suggestedMax" in axis && typeof axis.suggestedMax === "number") {
            if (typeof type.percentMax === "number") {
              axis.suggestedMax = Math.max(axis.suggestedMax, type.percentMax);
            }
          }
        }
      } else {
        yAxes[unit] = {
          position: Object.keys(yAxes).length === 0 ? "left" : "right",
          suggestedMin: asseYAuto ? undefined : type.percentMin ?? undefined,
          suggestedMax: asseYAuto ? undefined : type.percentMax ?? undefined,
          border: {
            display: false,
            dash: [5, 5],
          },
          grid: {
            display: true,
            drawOnChartArea: true,
            drawTicks: false,
          },
          ticks: {
            display: true,
            padding: 10,
            // color: "#b2b9bf",
            font: {
              size: 11,
              family: typography.fontFamily,
              style: "normal",
              lineHeight: 2,
            },
            callback: (value) => {
              if (typeof value === "number") {
                return proprietaMisurataFormat(type, value);
              } else {
                return value;
              }
            },
          },
        };
      }
    }
  }

  if (typeof rpmAxisMax === "number") {
    yAxes.rpmNexus = {
      position: "right",
      suggestedMin: 0,
      suggestedMax: rpmAxisMax,
      border: {
        display: false,
        dash: [5, 5],
      },
      grid: {
        display: false,
        drawOnChartArea: false,
        drawTicks: false,
      },
      ticks: {
        display: true,
        padding: 10,
        font: {
          size: 11,
          family: typography.fontFamily,
          style: "normal",
          lineHeight: 2,
        },
        callback: (value) => {
          return `${value} rpm`;
        },
      },
    };
  }

  const config: {
    data: ChartData<"line">;
    options: ChartOptions<"line">;
  } = {
    data: {
      // labels,
      datasets: [...datasets] as any,
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false,
        },
        tooltip: {
          enabled: true,
        },
        colors: {
          forceOverride: datasets.length > 1,
        },
      },
      interaction: {
        intersect: false,
        mode: "index",
      },
      scales: {
        ...yAxes,
        x: {
          type: "time",
          time: {
            displayFormats: {
              millisecond: "HH:mm:ss.SSS",
              second: "HH:mm:ss",
              minute: "HH:mm",
              hour: "DD/MM HH:mm",
              day: "DD/MM",
              week: "DD/MM",
              month: "MM/YYYY",
              quarter: "MM/YYYY",
              year: "YYYY",
            },
          },
          border: {
            display: false,
            dash: [5, 5],
          },
          grid: {
            display: false,
            drawOnChartArea: false,
            drawTicks: false,
          },
          ticks: {
            display: true,
            color: "#b2b9bf",
            padding: 20,
            font: {
              size: 11,
              family: typography.fontFamily,
              style: "normal",
              lineHeight: 2,
            },
          },
        },
      },
    },
  };

  return config;
}

export default configs;
